import { Component } from '@angular/core';

@Component({
  selector: 'app-coach-list',
  templateUrl: './coach-list.component.html',
  styleUrls: ['./coach-list.component.scss']
})
export class CoachListComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// /dist/src/app/user/coach/coach-list/coach-list.component.ts